import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { AlertBox, Icons, CustomLinkComponent, Button } from 'msp-components'

import { OrderActionProps } from '@/pages/account/AccountOrders/AccountOrderDetail/OrderActions/OrderActions.types'

import translations from './OrderReturnAction.constants'
import * as S from './OrderReturnAction.styles'

const OrderReturnAction = ({ order }: OrderActionProps) => {
  const { formatMessage } = useIntl()
  const confirmBoxRef = useRef<AlertBox>()

  return (
    <>
      <Button
        variant='outline'
        type='secondary'
        onClick={() => confirmBoxRef?.current.showAlert()}
      >
        {formatMessage(translations.returnOrder)}
      </Button>
      <AlertBox
        ref={confirmBoxRef}
        type='standard'
        headlineColor={S.DialogHeadline}
        title={formatMessage(translations.orderReturnTitle)}
        closeButtonIcon={<Icons iconName='Close' size='base' color='#000' />}
      >
        <div className={S.DialogDescriptionTitle}>
          {formatMessage(translations.orderReturnDescriptionTitle)}
        </div>
        <div className={S.DialogDescriptionContent}>
          {formatMessage(translations.orderReturnDescriptionContent)}
        </div>
        <div className={S.ListWrapper}>
          {order.c_returnLabel.map((returnLabel, index) => (
            <CustomLinkComponent
              key={`slip-${returnLabel.id}-${index}`}
              className={S.ListItemWrapper}
              uppercase={false}
              href={returnLabel.url}
              openInNewTab
              isExternalLink
              inline
            >
              <div className={S.ListItemContentWrapper}>
                <div className={S.ReturnLabelDownloadWrapper}>
                  <Icons iconName='Download' size='base' color='#000' />
                  <span className={S.ReturnLabelDownloadText}>
                    {formatMessage(translations.orderReturnDownload)}
                  </span>
                </div>
              </div>
            </CustomLinkComponent>
          ))}
        </div>

        <div className={S.DialogButtonsWrapper}>
          <Button
            type={'secondary'}
            onClick={() => confirmBoxRef?.current.closeAlert()}
          >
            {formatMessage(translations.orderReturnClose)}
          </Button>
        </div>
      </AlertBox>
    </>
  )
}

export default OrderReturnAction
